import assets from 'assets';
import React, { useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import theme from 'container/theme';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';

import styled from 'styled-components';
import { updateDocument } from 'container/api';

const Document = ({
  handleDocumentClick,
  doc,
  setSelectedDoc,
  setClickedDoc,
  selectedDoc,
}) => {
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);
  const [editTitle, setEditTitle] = useState('');
  const [title, setTitle] = useState('');
  const { selected } = useSelector(state => state.documents);

  const handleOnUpdateTitle = async e => {
    try {
      setTitle(editTitle);
      setEdit(false);
      await updateDocument({
        title: editTitle,
        id: selected?.id,
      });
      await dispatch.documents.getDocuments();
      dispatch.documents.setSelected({ ...selected, title: editTitle });
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleCancel = () => {
    setEditTitle(doc.title);
    setEdit(false);
  };

  const handleOnEdit = () => {
    setEdit(!edit);
  };

  useEffect(() => {
    setEditTitle(doc.title);
    setTitle(doc.title);
  }, [doc]);

  useEffect(() => {
    if (selected?.id !== doc?.id) {
      setEdit(false);
    }
    // eslint-disable-next-line
  }, [selected]);

  return (
    <DocumentItem
      className={selected?.id === doc?.id ? 'active' : ''}
      onClick={() => {
        handleDocumentClick(doc);
        setClickedDoc(doc);
      }}
    >
      <div className='flex-row first'>
        {edit ? (
          <TextBox
            rows={2}
            value={editTitle}
            onChange={e => setEditTitle(e.currentTarget.value)}
            // onKeyDown={e => e.key === 'Enter' && handleOnUpdateTitle(e)}
          ></TextBox>
        ) : (
          <p className='q-title font-size-14'>{title}</p>
        )}
        <div className='flex-row second' style={{ gap: edit ? '12px' : '6px' }}>
          {edit ? (
            <>
              <div
                className='icon-button'
                onClick={handleOnUpdateTitle}
                role='button'
              >
                <img src={assets.correct} alt='' />
              </div>
              <div className='icon-button' onClick={handleCancel} role='button'>
                <img src={assets.false} alt='' />
              </div>
            </>
          ) : (
            <>
              <div
                className='icon-button'
                id='edit-btn'
                onClick={handleOnEdit}
                role='button'
              >
                <img src={assets.edit} alt='' />
              </div>
              <Tooltip
                anchorSelect='#edit-btn'
                content='Edit'
                style={{ zIndex: '100', background: theme.colors.lightgrey }}
              />
            </>
          )}
        </div>
      </div>
      <div className='bottom-row'>
        <p className='font-size-10'>{dayjs(doc.created_at).fromNow()}</p>
        <div
          className='btn'
          role='button'
          onClick={e => {
            e.stopPropagation();
            setSelectedDoc(doc);
          }}
        >
          <img src={assets.delete} alt='' />
        </div>
      </div>
    </DocumentItem>
  );
};

export default Document;

const DocumentItem = styled.div`
  padding: 10px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  & .bottom-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;

    & .font-size-10 {
      color: ${({ theme }) => theme.colors.primary + '99'};
    }
  }

  & .btn {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.lightgrey};
    padding: 0px 5px;
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.lightgrey};
    border-radius: 7px;
  }

  & .flex-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    & p {
      margin: 0px;
    }

    &.second {
      gap: 7px;
    }
  }
`;

const TextBox = styled.textarea`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.lightgrey};
  resize: none;
  padding: 4px;
  border-radius: 5px;
  outline: none;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
`;
